import { render, staticRenderFns } from "./olPlace.vue?vue&type=template&id=630ee3e2&scoped=true"
import script from "./olPlace.vue?vue&type=script&lang=js"
export * from "./olPlace.vue?vue&type=script&lang=js"
import style0 from "./olPlace.vue?vue&type=style&index=0&id=630ee3e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630ee3e2",
  null
  
)

export default component.exports